/**
 * Banner + Assets layout (bskr/layout-banner-assets) — scroll-triggered fade-in
 * of the asset cards, staggered one after another.
 *
 * Loaded globally (layouts can't ship reliable per-block scripts). Skips the
 * editor and respects prefers-reduced-motion (cards stay visible).
 */

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function initBlock(root) {
  if (root.dataset.bannerAssetsInited === "1") return;

  const cards = root.querySelectorAll(".bskr-responsive-asset");
  if (!cards.length) return;

  // Inside a Content Slider slide the vertical scroll trigger can't fire (the
  // slide is translated horizontally); skip the reveal so the cards keep their
  // default visible state (see content-slider.js / content-slide markup).
  if (root.closest("[data-no-scroll-reveal]")) return;

  root.dataset.bannerAssetsInited = "1";
  // Flag the section so the CSS hides the cards (avoids a flash before GSAP
  // takes over); only added here, so no-JS users keep them visible.
  root.classList.add("is-anim-ready");

  gsap.set(cards, { opacity: 0, y: 24 });
  gsap.to(cards, {
    opacity: 1,
    y: 0,
    duration: 0.6,
    ease: "power2.out",
    stagger: 0.12,
    scrollTrigger: {
      trigger: root.querySelector(".bskr-banner-assets__assets") || root,
      start: "top 85%",
      once: true,
    },
  });
}

function init() {
  // Skip in the editor; leave reduced-motion users with static, visible cards.
  if (typeof window !== "undefined" && window.wp && window.wp.data) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  document
    .querySelectorAll(".wp-block-bskr-layout-banner-assets")
    .forEach(initBlock);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
